function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("defs", null, React.createElement("style", null, ".cls-1234{fill:none;stroke:#606060;stroke-linecap:round;stroke-linejoin:round;}"));

var _ref2 =
/*#__PURE__*/
React.createElement("g", {
  id: "Layer_2",
  "data-name": "Layer 2"
}, React.createElement("g", {
  id: "Layer_2-2",
  "data-name": "Layer 2"
}, React.createElement("polyline", {
  className: "cls-1234",
  points: "18.95 0.5 18.95 3.45 11.46 10.94 11.46 18.34 7.98 16.34 7.98 10.94 0.5 3.45 0.5 0.5 18.66 0.5"
})));

function SvgFilter(props) {
  return React.createElement("svg", _extends({
    viewBox: "0 0 19.44 18.84"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "static/media/filter.8dd0fccb.svg";
export { SvgFilter as ReactComponent };